import GlobalIcon from "../GlobalIcon/GlobalIcon";
import styles from "./MarketOverviewCards.module.css";

function MarketOverviewCards({ data = [], isLoading = false, className }) {
  if (isLoading && data.length === 0) {
    return (
      <div className={`${styles.wrapper} ${className || ""}`}>
        <div className={styles.loadingMessage}>Loading market overview...</div>
      </div>
    );
  }

  if (!data.length) {
    return null;
  }

  return (
    <div className={`${styles.wrapper} ${className || ""}`}>
      {data.map((index) => (
        <div
          key={index.id}
          className={`${styles.card} ${index.changeIsPositive ? styles.positiveCard : styles.negativeCard}`}
        >
          <div className={styles.left}>
            <div className={styles.title}>{index.title}</div>
            <div
              className={`${styles.value} ${index.changeIsPositive ? styles.positive : styles.negative}`}
            >
              {index.value}
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.change}>{index.change}</div>
            <div
              className={`${styles.percent} ${index.changeIsPositive ? styles.positive : styles.negative}`}
            >
              <GlobalIcon
                iconName="MarketChangeArrowIcon"
                className={styles.arrow}
              />
              <span>{index.changePercent}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MarketOverviewCards;
